// jshint module: true, freeze: false

// enable ''.startsWith() in IE
// NOTE: This polyfill is very basic. For a more robust implementation, see: https://mths.be/startswith
String.prototype.startsWith = String.prototype.startsWith || function(searchString, position) {

  position = position || 0;

  return this.substr(position, searchString.length) === searchString;
};



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/string-startswith.js